import { Link, useSearchParams } from 'react-router-dom';
import { ShieldOff, ArrowLeft, Settings } from 'lucide-react';
import { Button } from '@/app/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/app/components/ui/card';
import { usePermissions } from '@/hooks/use-permissions';

export function ModuleNotEnabledPage() {
  const [searchParams] = useSearchParams();
  const moduleName = searchParams.get('module') ?? 'This module';
  const noAccess = searchParams.get('reason') === 'no_access';
  const { isAdmin } = usePermissions();

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6">
      <div className="flex items-center gap-4">
        <Button variant="outline" size="icon" asChild>
          <Link to="/dashboard">
            <ArrowLeft className="h-4 w-4" />
          </Link>
        </Button>
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Module Not Enabled</h1>
        </div>
      </div>

      <Card>
        <CardHeader className="flex flex-col items-center text-center py-12">
          <ShieldOff className="h-16 w-16 text-gray-400 mb-4" />
          <CardTitle className="text-2xl">
            {noAccess ? `You don't have access to ${moduleName}` : `${moduleName} is not enabled`}
          </CardTitle>
          <CardDescription className="max-w-md mt-2">
            {noAccess
              ? 'Contact your administrator if you need access to this module.'
              : 'This module has not been enabled for your organization. Contact your administrator to enable it.'}
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center gap-3 pb-8">
          <Button variant="outline" asChild>
            <Link to="/dashboard">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back to Dashboard
            </Link>
          </Button>
          {isAdmin && (
            <Button asChild>
              <Link to="/settings/modules">
                <Settings className="h-4 w-4 mr-2" />
                Manage Modules
              </Link>
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
